import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const GaugeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Gauge",
    children: /*#__PURE__*/_jsx("path", {
      d: "m19.67 22.42 5.96-10.47a.898.898 0 0 0-.13-1.04.88.88 0 0 0-1.05-.15s-10.5 5.9-10.5 5.9c-.33.2-.62.43-.87.7-.76.77-1.24 1.82-1.24 2.99 0 2.34 1.89 4.23 4.23 4.23 1.17 0 2.23-.47 2.99-1.24q.36-.405.6-.9v-.02zM16 22.17c-.5 0-.95-.2-1.28-.53s-.54-.78-.54-1.28.21-.96.54-1.28a1.83 1.83 0 0 1 2.56 0c.33.33.53.78.53 1.28 0 1-.81 1.81-1.8 1.81Zm3.5-10.66 3.71-2.09c-2.06-1.26-4.55-2-7.21-2-7.72 0-13.98 6.25-14 13.97 0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75c0-5.8 4.7-10.5 10.5-10.5 1.26 0 2.46.23 3.57.64zm7.58 1.36-1.93 3.4c.84 1.47 1.34 3.24 1.35 5.12 0 .97.78 1.75 1.75 1.75S30 22.36 30 21.39c0-3.22-1.1-6.19-2.95-8.54l.02.03Z"
    })
  }));
};